<template>
	<modal
		size="small-medium"
		class="modal-display"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Output') }}</span>
			<span v-else>{{ $t('Edit Output') }}</span>
		</template>
		<template slot="body">
			<form @submit.prevent="">
				<!-- Name -->
				<div class="form-group">
					<label>{{ $t('Output Name') }}</label>
					<input
						type="text"
						name="name"
						class="form-control"
						v-model="name"
						required>
				</div>
				<!-- Size -->
				<div class="form-group select">
					<label>{{ $t('Size') }}</label>
					<div class="mh-40px">
						<multiselect class="select-input" v-model="size" deselect-label="Can't remove this value" track-by="name" label="name"
						placeholder=" " :options="sizes" :searchable="false" :allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						</multiselect>
					</div>
				</div>
				<!-- Display Index Filter -->
				<div class="form-group mb-0">
					<div class="d-flex justify-content-between">
						<label class="mr-4">{{ $t('Output layers') }}</label>
						<label class="label" :class="{'text-red': indexFilter.length === 0}">{{ $t('Type and press Enter to save, and repeat') }}</label>
					</div>
					<md-chips
					class="form-control display-index-input mb-0 placeholder-small"
						md-input-type="number"
						v-model="indexFilter"
						md-placeholder="Type here ( Fill with '0' if you want to display on all Layers )"
						:md-limit="limit">
						<template slot="md-chip" slot-scope="{ chip }">
							{{ chip }}
						</template>
					</md-chips>
					<div class="text-right pt-1">
						<a href="https://support.grafi.as/" target="_blank" rel="noopener" class="text-primary">{{$t('Learn more on output layers')}}</a>
					</div>
				</div>
				<!-- Exclude Display Index Filter -->
				<!-- <div class="form-group mb-0">
					<div class="d-flex justify-content-between">
						<label class="mr-4">{{ $t('Exclude Index') }}</label>
						<label class="label">{{ $t('Type and press Enter to save, and repeat') }}</label>
					</div>
					<md-chips
					class="form-control display-index-input mb-0 placeholder-small"
						md-input-type="number"
						v-model="excludeIndexFilter"
						md-placeholder="Type here ( Leave it blank if you don't have exclude Layers )"
						:md-limit="limit">
						<template slot="md-chip" slot-scope="{ chip }">
							{{ chip }}
						</template>
					</md-chips>
					<div class="text-right pt-1">
						<a href="https://grafi.as/learn/displayindexfilter" target="_blank" class="text-primary">{{$t('Learn more on output layers')}}</a>
					</div>
				</div> -->
				<!-- delay -->
				<div class="form-group col-md-4 mr-0 pr-0 ml-0 pl-0 relative">
					<label>{{ $t('Delay') }}</label>
					<custom-input
						:min="0"
						:max="15000"
						:step="100"
						type="number"
						name="delay"
						class="form-input mb-3"
						v-model="delay"/>
					<span class="suffix-delay-output">ms</span>
				</div>
				<!-- Background Color -->
				<div class="form-group select mb-3">
					<label>{{ $t('Output Type') }}</label>
					<div class="mh-40px">
						<multiselect class="select-input" v-model="bgColor" deselect-label="Can't remove this value" track-by="name" label="name"
						placeholder=" " :options="backgroundOptions" :searchable="false" :allow-empty="false" :show-labels="false">
						<span class="arrow-multiselect" slot="caret">
							<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
						</span>
						</multiselect>
					</div>
					<div class="text-right">
						<a href="https://support.grafi.as/" target="_blank" rel="noopener" class="text-primary">{{$t('Learn more on using the different output types')}}</a>
					</div>
				</div>
				<!-- <div class="d-flex"> -->
					<!-- Preload -->
					<!-- <label class="custom-control custom-checkbox mb-3">
						<input type="checkbox" class="custom-control-input" v-model="isPreload">
						<span class="custom-control-label pt-1">{{ $t('Preload content on desktop app') }}</span>
						<div class="text-grey">{{ $t('All content on your rundown attached to this display will be preloaded for better performance') }}</div>
					</label>
				</div> -->
				<!-- Access Limit -->
				<!-- <div class="form-group mb-5">
					<label>{{ $t('Access Limit') }}</label>
					<input
						type="number"
						name="name"
						class="form-control"
						v-model="accessLimit"
						required>
				</div> -->
				<div class="d-flex justify-content-between modal-actions mt-3 mb-3">
					<!-- Submit -->
					<button
						:disabled="!isValid"
						type="button"
						class="btn btn-primary"
						@click="save()"
						:class="{ 'is-loading': isSaving }">
						<span v-if="!data">{{ $t('Create Output') }}</span>
						<span v-else>{{ $t('Save Changes') }}</span>
					</button>
					<!-- Copy Display URL -->
					<button
						type="button"
						class="btn btn-submit btn-default"
						@click="copyDisplayUrl"
						v-if="data">
						<span>{{ $t('Copy Output URL') }}</span>
					</button>
					<!-- Copy Embed Code -->
					<!-- <button
						type="button"
						class="btn btn-submit btn-default"
						@click="copyEmbedCode"
						v-if="data">
						<span>{{ $t('Copy Embed Code') }}</span>
					</button> -->
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Modal from '@/components/Modal.vue';
import CustomInput from '@/components/CustomInput.vue';
import { getAxiosErrorMessage, copyToClipboard } from '@/lib/helper';
import displaysApi from '@/api/displays';


export default {
	name: 'DisplayForm',
	props: {
		data: {
			type: Object,
		},
		sizes: {
			type: Array,
		},
	},
	components: {
		Modal,
		Multiselect,
		CustomInput,
	},
	data() {
		return {
			name: '',
			description: '',
			isActive: '',
			isDefault: '',
			indexFilter: ['0'],
			excludeIndexFilter: [],
			delay: 0,
			size: null,
			isTransparent: false,
			isPreload: false,
			isSaving: false,
			bgColor: { key: 'background:none', name: 'Transparent (Straight Alpha)' },
			limit: 20,
			accessLimit: 20,
			backgroundOptions: [
				{ key: '#000000', name: 'Black (Luma Key)' },
				{ key: '#00FF00', name: 'Green (Chroma Key)' },
				{ key: 'background:none', name: 'Transparent (Straight Alpha)' },
				// { key: 'fillkey', name: 'Only Key' },
			],
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const user = response.data;
				const message = response.message;
				this.$emit('saved', user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Display',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Display',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				displaysApi.update(this.data.id, params, callback, errorCallback);
			} else {
				displaysApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.name = '';
			this.description = '';
			this.isActive = true;
			this.isDefault = false;
			this.size = this.sizes[0];
			this.isTransparent = false;
			this.isPreload = false;
			this.accessLimit = 20;
			this.delay = 0;
		},
		setData(data) {
			this.name = data.name;
			this.description = data.description;
			this.isActive = data.is_active;
			this.isDefault = data.is_default;
			const indexSize = this.sizes.findIndex(({ id }) => id === data.display_size_id);
			this.size = this.sizes[indexSize];
			this.isTransparent = data.is_transparent_background;
			this.isPreload = data.is_preload_content;
			this.accessLimit = data.access_limit;
			this.delay = data.delay ? data.delay : 0;
			// include
			const dataLayerIndex = data && data.layer_index ? data.layer_index : '';
			if (dataLayerIndex === '0') {
				this.indexFilter = ['0'];
			} else {
				this.indexFilter = JSON.parse(data.layer_index);
			}
			// exclude
			const dataExcludeLayerIndex = data && data.exclude_layer_index ? data.exclude_layer_index : '';
			if (dataExcludeLayerIndex.length === 0) {
				this.excludeIndexFilter = [];
			} else {
				this.excludeIndexFilter = JSON.parse(data.exclude_layer_index);
			}
			const index = this.backgroundOptions.findIndex(({ key }) => key === data.background_color);
			this.bgColor = this.backgroundOptions[index];
		},
		copyDisplayUrl() {
			const rundownId = this.data && this.data.rundown && this.data.rundown.id ? this.data.rundown.id : '';
			const slug = this.data.slug;
			const id = this.data.id;
			const baseUrl = process.env.VUE_APP_URL;
			const url = `${baseUrl}/displays/live/${btoa(slug)}/${id}?rundown_id=${rundownId}`;
			copyToClipboard(url);
			const message = this.$t('Copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Display URL',
				text: message,
			});
		},
		copyEmbedCode() {
			copyToClipboard(this.embedCode);
			const message = this.$t('Copied to clipboard');
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Embed Code',
				text: message,
			});
		},
	},
	computed: {
		params() {
			const name = this.name ? this.name.trim() : '';
			const description = this.description ? this.description.trim() : '';
			const isActive = this.isActive;
			const isDefault = this.isDefault;
			const layerIndex = JSON.stringify(this.indexFilter);
			const excludeLayerIndex = JSON.stringify(this.excludeIndexFilter);

			const size = this.size ? this.size : '';
			const params = {
				name,
				description,
				display_size_id: size && size.id ? size.id : '',
				is_active: isActive,
				is_default: isDefault,
				is_transparent_background: this.isTransparent,
				is_preload_content: this.isPreload,
				background_color: this.bgColor.key,
				delay: this.delay,
			};
			if (this.accessLimit) {
				params.access_limit = this.accessLimit;
			} else {
				params.access_limit = 20;
			}
			if (!layerIndex) {
				params.layer_index = 0;
			} else {
				params.layer_index = layerIndex;
			}
			if (!excludeLayerIndex) {
				params.exclude_layer_index = [];
			} else {
				params.exclude_layer_index = excludeLayerIndex;
			}
			return params;
		},
		embedCode() {
			const embedCode = this.data && this.data.unique_code ? this.data.unique_code : '';
			return embedCode;
		},
		isValid() {
			return (
				this.bgColor !== ''
				&& this.size !== ''
				&& this.name !== ''
				&& this.indexFilter.length !== 0
			);
		},
	},
	created() {
		this.initData();
	},
	watch: {
		name(val) {
			this.name = val.replace(/[^A-Z0-9 ]/gi, '');
		},
	},
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
